/**
 * @desc factoryDirectCreateLineSnapShot
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.factoryDirectCreateLineSnapShotRequestDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/Batch/allocation/factoryDirect`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
